export default __webpack_public_path__ + "static/bamboo-button-25096c6a8825ec812e9e6e4967412fa7.png";